import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@core/environments/environment';
import { Pagination } from '@core/models/pagination.model';
import { LoadingService } from './loading.service';
import { finalize, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IdentityLogService {
  http = inject(HttpClient);
  BASE_URL = environment.ADMIN_BASE_URL + '/v1/admin';

  loadingService = inject(LoadingService);

  constructor() {}

  getIdentityLogs(data?: Pagination, search_text?: string): Observable<IdentityLogsListResponse> {
    const uniqueStateUrl = 'get-identity-logs';
    this.loadingService.setLoading(uniqueStateUrl, true);
    let url = '';

    if (search_text) {
      url = `${this.BASE_URL}/get-all-identity-records?${search_text}`;
    } else {
      url = `${this.BASE_URL}/get-all-identity-records?take=${data?.size}&skip=${data?.skip}`;
    }

    return this.http
      .get<IdentityLogsListResponse>(url)
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }
}


interface IdentityLogsListResponse {
    status: string;
    message: string;
    data: {
        data: IdenityData[];
        total_count: number;
    };
}



interface IdenityData {
    id: string;
    identity_number: string;
    type: string;
    first_name: string;
    last_name: string;
    middle_name: string;
    email: string;
    gender: string;
    residential_address: string;
    phone_number1: string;
    phone_number2: string;
    date_of_birth: string;
    marital_status: string;
}